// ✅ FILE: src/firebaseConfig.js

import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, initializeFirestore, connectFirestoreEmulator, doc, getDoc, setDoc, updateDoc, serverTimestamp, Timestamp, collection, getDocs, query, where, limit, writeBatch } from "firebase/firestore";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getDatabase } from "firebase/database";

// --- Your Firebase project config ---
const firebaseConfig = {
  apiKey: "AIzaSyDyqTCxDZARkzHLeO7U_34zjNpr2Jart3I",
  authDomain: "thescope180.com",
  projectId: "thescope360",
  storageBucket: "thescope360.firebasestorage.app",
  messagingSenderId: "1083585761815",
  appId: "1:1083585761815:web:5908d207568fdb69cdc252",
  databaseURL: "https://thescope360-default-rtdb.firebaseio.com",
};

// Local testing only: REACT_APP_USE_EMULATORS=1 points Auth, Firestore and
// Functions at the local emulators (demo project, no live data). See
// firebase.ssd-local.json and scripts/ssd/emulator-seed.js.
const USE_EMULATORS = process.env.REACT_APP_USE_EMULATORS === "1";
if (USE_EMULATORS) firebaseConfig.projectId = "demo-thescope360";

// --- Initialize core SDKs ---
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Long polling in emulator mode: some embedded browsers drop the streaming channel
export const db = USE_EMULATORS ? initializeFirestore(app, { experimentalForceLongPolling: true }) : getFirestore(app);
export const storage = getStorage(app);
export const rtdb = getDatabase(app);
export const functions = getFunctions(app, "us-central1");

if (USE_EMULATORS) {
  connectAuthEmulator(auth, "http://127.0.0.1:9199", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8181);
  connectFunctionsEmulator(functions, "127.0.0.1", 5101);
}

// if you need Cloud Functions (optional by region)
export const getFunctionsClient = (region = "us-central1") =>
  getFunctions(app, region);

// Expose Firebase to window for admin scripts (browser console uploads)
if (typeof window !== 'undefined') {
  window.db = db;
  window.auth = auth;
  window.firestore = { doc, getDoc, setDoc, updateDoc, serverTimestamp, Timestamp, collection, getDocs, query, where, limit, writeBatch };
  window.storage = storage;
  window.storageHelpers = { ref, listAll, getDownloadURL };
}